import { useThemeMode } from "../../context/contextTheme";
import { useDesign } from "../../context/contextDesign";
import ChartGraph from "./graph/chart";
import Report from "./graph/report";

const GraphView = () => {
  const { theme } = useThemeMode();
  const { bHeightVal } = useDesign();

  return (
    <div className="animate__animated animate__fadeIn">
      <div className="d-flex align-items-center gap-2 mb-3">
        <i className="bi bi-clock-history fs-3" style={{ color: theme.primary }}></i>
        <div className="fs-3 fw-bold" style={{ color: theme.textColor }}>
          Security Intelligence History
        </div>
      </div>
               
      <div className="d-flex flex-column flex-lg-row gap-3 overflow-y-auto" 
        style={{ height: `calc(${bHeightVal} - 20px)` }}>
        <div className="flex-grow-1 card border-1 shadow-sm rounded-4 p-3">
          <ChartGraph />
        </div>
        <div className="card border-1 shadow-sm rounded-4 p-3" style={{ width: '100%', maxWidth: '450px' }}>
          <Report />
        </div>
      </div>
    </div>
  );
};

export default GraphView;